import PropTypes from 'prop-types';
import React, { useState } from 'react';
import classnames from 'classnames';

import { Stack, Label } from '@bingads-webui-react/fabric-control';
import { FocusLock } from '@bingads-webui-react/focus-lock';
import { NameEditor } from '../../components/name-editor';
import { ImageItemModelShape } from '@bingads-webui-react/image-picker'; //eslint-disable-line

const getUserImageItemWrapper = ({
  i18n, isForVNext, onUserImageDelete, onUserImageEdit, isAdCreatorEnabled, isForThumbnail,
}) => {
  const UserImageItemWrapper = (props) => {
    const {
      children,
      itemHeight,
      image,
      isSelected,
    } = props;

    const [editMode, setEditMode] = useState(false);
    const [imageText] = useState(image.textFields[0]);
    const [imageEditText, setImageEditText] = useState('');

    const thumbnailHeight = itemHeight;
    const thumbnailWidth = Math.round((image.width * thumbnailHeight) / image.height);
    const limitedThumbnailWidth =
            thumbnailWidth / thumbnailHeight > 1.6 ? thumbnailHeight * 1.6 : thumbnailWidth;

    const wrapperStyle = {
      /* istanbul ignore next */
      maxHeight: thumbnailHeight + (isForThumbnail? 30: 45),
      /* istanbul ignore next */
      height: thumbnailHeight + (isForThumbnail? 30: 45),
      width: limitedThumbnailWidth + 4, // + 4 so that the outline shows up upon getting focus
      position: 'relative',
      overflow: 'visible',
      margin: '5px',
    };

    const onDelete = (clickEvent) => {
      const imageIdString = clickEvent.currentTarget.attributes['data-imageid'].value;

      return onUserImageDelete(imageIdString);
    };

    const onImageEdited = (imageIdString, newImageText) => {
      onUserImageEdit(imageIdString, newImageText);
    };

    return (
      <div style={wrapperStyle} className="existing-image-container">
        <div className="image-section-wrapper" style={{ overflow: 'hidden' }}>
          <div className="image-section">
            <div className="image-content-wrap" data-imageid={image.idString} style={{ border: isSelected ? '2px solid #0078D4' : 'none' }}>
              {children}
            </div>
            {
              !isForVNext &&
              (
                <div className="image-dimensions">
                  {`${image.width} x ${image.height}`}
                </div>
              )
            }
            {
              !isForVNext &&
              (
                <button
                  id={image.idString}
                  className="image-edit glyphicon glyphicon-pencil"
                  onClick={() => { setImageEditText(imageText); setEditMode(true); }}
                  aria-label={i18n.getString('ImageExperience_Edit_Image_Name')}
                />
              )
            }
            <button
              id={`image-delete-${image.idString}`}
              data-imageid={image.idString}
              className={classnames('image-delete glyphicon glyphicon-remove', isAdCreatorEnabled ? 'circular-hover' : '')}
              onClick={onDelete}
              aria-label={i18n.getString('ImageExperience_Remove_Image')}
            />
          </div>
        </div>
        {
            !editMode &&
            (
              <Stack>
                <div className="image-name-section">
                  <span className="image-name">
                    {imageText}
                  </span>
                  {
                    isForVNext &&
                    (
                      <button
                        id={`image-edit-${image.idString}`}
                        className="image-edit glyphicon glyphicon-pencil"
                        onClick={() => { setImageEditText(imageText); setEditMode(true); }}
                        aria-label={i18n.getString('ImageExperience_Edit_Image_Name')}
                      />
                    )
                  }
                </div>
                {
                /* istanbul ignore next */
                !isForThumbnail &&
                <div className="image-info-section">
                  <Label className="image-id">{image.idString}</Label>
                </div>
                }
              </Stack>
            )
        }
        {
            editMode &&
            (
              <FocusLock
                focusFirstItemOnMount
                isControlledFocusLock
                isFocusLock={editMode}
                onExit={() => setEditMode(false)}
              >
                <NameEditor
                  id={`name-editor-${image.idString}`}
                  value={imageEditText}
                  i18n={i18n}
                  onChanged={e => setImageEditText(e.target.value)}
                  onSave={() => {
                    onImageEdited(image.idString, imageEditText);
                    setEditMode(false);
                  }}
                  onCancel={() => setEditMode(false)}
                />
              </FocusLock>
            )
        }
      </div>
    );
  };

  UserImageItemWrapper.propTypes = {
    children: PropTypes.element.isRequired,
    image: ImageItemModelShape.isRequired,
    itemHeight: PropTypes.number.isRequired,
    isSelected: PropTypes.bool,
  };

  UserImageItemWrapper.defaultProps = {
    isSelected: false,
  };

  return UserImageItemWrapper;
};

export default getUserImageItemWrapper;
